import template from './template';
import entry from './plugins/entry';
import globalStyle from './plugins/globalStyle';
import packageJSON from './plugins/packageJSON';
import lowcodeConfigJSON from './plugins/lowcodeConfigJSON';
import router from './plugins/router';

export default {
  template,
  plugins: {
    entry,
    globalStyle,
    packageJSON,
    lowcodeConfigJSON,
    router,
  },
};
